export const APP_CONSTANTS = {
  // CURRENCY_SYMBOL: '₹',
  // CURRENCY_FORMAT: 'en-IN',
  // COUNTRY: "India",
  // PHONE_NUMBER_FORMAT: "[eg: +91 12345 67890]",
  // PHONE_NUMBER_LENGTH: 15,


  CURRENCY_SYMBOL: '$',
  CURRENCY_FORMAT: 'en-US',
  COUNTRY: "USA",
  PHONE_NUMBER_FORMAT: "[eg: +1 (123) 456-7890]",
  PHONE_NUMBER_LENGTH: 17,


  // Changes in commonService in abbreviateNumber(), labelFormatter().
  // Changes in directives => FormatPhoneNumberDirective & its max length

};
